import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import httpStatus from 'http-status'
import { Container, Alertbox, Link } from '@olxbr/ds-web'
import { Mail } from '@olxbr/ds-icons'
import PinCode from '../../molecules/PinCode'
import { CountdownContext } from '../../../util/providers/CountdownProvider'
import { formatedTime } from '../../../util/date'
import {
  sendEmailPincodeRequest,
  checkEmailPincodeRequest,
  checkEmailPincodeRequestRevalidation,
} from '../../../api/emailLogin'
import passwordlessSendEmailApiCall from '../../../api/passwordlessSendEmailApiCall'
import LoadingBackdrop from '../../molecules/LoadingBackdrop'
import { SentTo } from '../../organisms/SentTo'
import Lurker from '../../../util/lurker'
import useWindowSize from '../../../util/useWindowSize'
import { splitLoginEmailCheckAttempts } from '../../../api/attemptCheckAPI'
import {
  getModalLoginExtraData,
  isAccountRevalidationExperimentOn,
} from '../../../util/experiments'
import { View } from '../../atoms/View'
import storage from '../../../util/storage'
import {
  EMAIL_PINCODE_LOGIN_METHOD,
  LOGIN_METHOD_KEY,
  MANDATORY_TIPIFICATION_KEY,
} from '../../../util/global.consts'
import { isValidMustTypify } from '../../../util/account'
import { isLoginScrollEnabled } from '../../../util/experiments'
import TermsAndPrivacyNotice from '../../molecules/TermsAndPrivacyNotice'
import { breakpoints } from '../../../util/medias'
import { Avatar } from '@olxbr/ds-core'

const DESKTOP_BP = `${breakpoints.tablet + 1}px`

const Content = styled.div`
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  margin: auto;
  margin-top: 64px;
  overflow: hidden;
  margin-bottom: 64px;
  max-width: 466px;
  ${({ modalMode }) =>
    modalMode &&
    `
    margin-top: 8px;
    margin-bottom: 8px;
    max-width: unset;
  `}
`

const ContentWrapper = styled.div`
  text-align: center;
  width: 100%;
`

const StyledText = styled.span.attrs({ className: 'typo-body-small' })`
  text-align: left;
`

const getContentElement = ({ modalMode, ...props }) =>
  modalMode ? <View {...props} /> : <Container {...props} />

const ContentContainer = styled(getContentElement)``

const NewPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 88px);
  overflow: hidden;
  @media (min-width: ${DESKTOP_BP}) {
    margin-top: var(--spacing-6);
    height: auto;
    overflow: visible;
    display: block;
  }
`

const TwoColumnWrapper = styled.div`
  margin: 0 auto;
  flex: 1;
  @media (min-width: ${DESKTOP_BP}) {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    max-width: 1040px;
    padding: var(--spacing-6) var(--spacing-4) 0;
    gap: var(--spacing-7);
  }
`

const LeftColumn = styled.div`
  display: none;
  @media (min-width: ${DESKTOP_BP}) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    max-width: 469px;
  }
`

const RightColumn = styled.div`
  @media (min-width: ${DESKTOP_BP}) {
    width: 504px;
    flex-shrink: 0;
  }
`

const NewMobileHeader = styled.div`
  padding: var(--spacing-3) var(--spacing-2) 0;
  @media (min-width: ${DESKTOP_BP}) {
    display: none;
  }
`

const NewCardContent = styled.div`
  padding: var(--spacing-2);
  @media (min-width: ${DESKTOP_BP}) {
    border: var(--border-width-0-1) solid var(--container-border-color-outlined);
    border-radius: var(--border-radius-1);
    padding: var(--spacing-4) var(--spacing-7);
  }
`

const NewDesktopFooter = styled.div`
  margin-top: auto;
  padding-top: var(--spacing-7);
`

const NewMobileFooter = styled.div`
  display: flex;
  justify-content: center;
  max-width: 466px;
  margin: auto;
  margin-top: auto;
  text-align: center;
  padding: var(--spacing-1) var(--spacing-2);
  @media (min-width: ${DESKTOP_BP}) {
    display: none;
  }
`

const HideOnMobile = styled.div`
  @media (max-width: ${parseInt(DESKTOP_BP) - 1}px) {
    display: none;
  }
`

// Needs to be dynamic when pincode by sms implemented (*_email / *_sms)
const lurker = new Lurker('login_pincode_email')

const LOGIN_TYPE = 'EMAIL'

let authToken
export const SplitLoginEmailPinCodeCheckTemplate = ({
  email,
  onSuccess,
  onBackClick,
  onChallengePinCodeCall,
  abTests,
  onPhoneNotValidatedError,
  sessionTokens,
  onAccountNotValidated,
  onAccountMustValidate,
  modalMode = false,
  onAccountCompleteData,
  onPrivacyLinkClick,
  onTermsLinkClick,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [hasPincodeError, setHasPincodeError] = useState(false)
  const [hasError, setHasError] = useState(false)
  const [errorMessage, setErrorMessage] = useState({})
  const { lockTime, checkAttemptLockTime } = useContext(CountdownContext)
  const { isMobile } = useWindowSize()
  const experimentOn = isLoginScrollEnabled(abTests)

  const checkAttempts = () => splitLoginEmailCheckAttempts(authToken)

  const sendEmailPicode = (email, resend) => {
    const extraData = getModalLoginExtraData(abTests, modalMode)
    sendEmailPincodeRequest(email)
      .then(response => {
        authToken = response.data.token
        checkAttemptLockTime(checkAttempts)
        lurker.viewMessageEvt('pincode_email_sent', { resend, ...extraData })
      })
      .catch(error => {
        lurker.viewMessageEvt('pincode_email_send_error', { resend, ...extraData })
      })
  }

  const resendPincode = email => {
    lurker.clickEvt('resend_pincode')
    sendEmailPicode(email, true)
  }

  const onApiError = (error = {}) => {
    const { response = {} } = error
    const { status = null } = response
    const { message = '' } = response.data || {}

    if (!status || (status >= 200 && status < 300)) {
      return
    }

    if (status >= 300 && status < 400) {
      return
    }

    let errorMessage = {
      message: 'Não foi possível acessar sua conta. Por favor, tente novamente.',
    }
    const extraData = getModalLoginExtraData(abTests, modalMode)

    const errorActions = {
      [httpStatus.UNAUTHORIZED]: () => {
        if (message === 'PIN_CODE' && typeof onChallengePinCodeCall === 'function') {
          storage.set(LOGIN_METHOD_KEY, EMAIL_PINCODE_LOGIN_METHOD)
          onChallengePinCodeCall(response.data)
        } else if (
          message === 'PHONE_NOT_VALIDATED' &&
          typeof onPhoneNotValidatedError === 'function'
        ) {
          lurker.redirectEvt('phone_validation')
          storage.set(LOGIN_METHOD_KEY, EMAIL_PINCODE_LOGIN_METHOD)
          onPhoneNotValidatedError(response.data.token)
        } else if (message === 'ACCOUNT_NOT_VALIDATED') {
          lurker.viewMessageEvt('error', {
            accounts_reason: message.toLowerCase(),
            accounts_status_code: httpStatus.UNAUTHORIZED,
            ...extraData,
          })

          onAccountNotValidated(response.data.token)
        } else if (message === 'ACCOUNT_TYPING_REQUIRED') {
          lurker.viewMessageEvt('error', {
            accounts_reason: message.toLowerCase(),
            accounts_status_code: httpStatus.UNAUTHORIZED,
            login_type: 'pincode_email',
            ...extraData,
          })

          storage.set(MANDATORY_TIPIFICATION_KEY, true)

          if (onAccountCompleteData) {
            onAccountCompleteData(response?.data?.token)
          }
        } else if (
          message === 'ACCOUNT_MUST_VALIDATE' &&
          typeof onAccountMustValidate === 'function'
        ) {
          lurker.viewMessageEvt('error', {
            accounts_reason: message.toLowerCase(),
            accounts_status_code: httpStatus.UNAUTHORIZED,
            ...extraData,
          })

          onAccountMustValidate(response.data.token)
        }
      },
      [httpStatus.TOO_MANY_REQUESTS]: () => {
        let lurkerMessage = `rate_limit_exceeded`

        if (message === 'MAX_CHECK_ATTEMPTS_REACHED') {
          passwordlessSendEmailApiCall(email)
          errorMessage = {
            title: 'Tentativas excedidas',
            message:
              'Limite de tentativas atingido. Enviamos um e-mail com novas instruções de acesso.',
          }
          setHasError(true)
          setErrorMessage(errorMessage)
          lurkerMessage = 'max_account_check_attempts'
        }

        lurker.viewMessageEvt('error', {
          accounts_reason: lurkerMessage,
          accounts_status_code: status,
          ...extraData,
        })
      },
      [httpStatus.FORBIDDEN]: () => {
        if (message === 'INVALID_PIN_CODE') {
          setHasPincodeError(true)
          lurker.viewMessageEvt('error', {
            accounts_reason: 'invalid_pin_code',
            accounts_status_code: status,
            ...extraData,
          })
        }
      },
      default: () => {
        setHasError(true)
        setErrorMessage(errorMessage)
        lurker.viewMessageEvt('error', {
          accounts_reason: `unexpected_status_code`,
          accounts_status_code: status,
          ...extraData,
        })
      },
    }

    const action = errorActions[status] || errorActions[error?.message] || errorActions.default
    return action()
  }

  const checkPinCode = async (code, token) => {
    const checkEmailPincodeRequestApiCaller = isAccountRevalidationExperimentOn(abTests)
      ? checkEmailPincodeRequestRevalidation(code, token, sessionTokens)
      : checkEmailPincodeRequest(code, token, sessionTokens, abTests)

    const extraData = getModalLoginExtraData(abTests, modalMode)

    const isMustTypify = await isValidMustTypify()

    checkEmailPincodeRequestApiCaller
      .then(data => {
        const { publicAccountId, isTypified } = data
        lurker.setPublicAccountId(publicAccountId)

        setIsSubmitting(false)
        if (typeof onSuccess === 'function') {
          if (!isTypified && isMustTypify) {
            return onAccountCompleteData(data?.token)
          }

          lurker.viewMessageEvt('login_success', {
            accountId: data.accountId,
            flow: 'pincode_email',
            context: LOGIN_TYPE,
            ...extraData,
          })

          onSuccess({ ...data, method: EMAIL_PINCODE_LOGIN_METHOD })
        }
      })
      .catch(error => {
        onApiError(error)
        setIsSubmitting(false)
      })
      .finally(() => setIsSubmitting(false))
  }

  const onPinCodeChange = (pinCode, isValid, token) => {
    setIsSubmitting(false)
    if (isValid) {
      setHasPincodeError(false)
      checkPinCode(pinCode, token)
      setIsSubmitting(true)
    }
  }

  const handleBackClick = () => {
    lurker.clickEvt('back')
    if (typeof onBackClick === 'function') {
      onBackClick()
    }
  }

  useEffect(() => {
    lurker.pageLoadEvt()
    sendEmailPicode(email, false)
  }, [])

  const pincodeFormContent = (
    <>
      {hasError && (
        <div className="flex mb-4">
          <Alertbox title={errorMessage.title} variant="error">
            <StyledText>{errorMessage.message}</StyledText>
          </Alertbox>
        </div>
      )}

      <div className="flex mb-1 justify-center">
        <PinCode
          modalMode={modalMode}
          onChange={(pincode, isValid) => {
            onPinCodeChange(pincode, isValid, authToken)
          }}
          hasError={hasPincodeError}
        />
      </div>

      {hasPincodeError && (
        <div className="flex mb-2">
          <span className="typo-body-small text-feedback-error-100">Código inválido</span>
        </div>
      )}

      {!hasPincodeError && <div className="flex mb-3" />}

      <div className="flex mb-3 justify-start">
        {!(lockTime > 0 || isSubmitting) ? (
          <Link
            size="small"
            onClick={() => {
              resendPincode(email)
            }}
          >
            Reenviar código
            {lockTime > 0 ? ` em ${formatedTime(lockTime)}` : ''}
          </Link>
        ) : (
          <span className="typo-body-small text-neutral-100">
            Reenviar código
            {lockTime > 0 ? ` em ${formatedTime(lockTime)}` : ''}
          </span>
        )}
      </div>

      <div className="flex mb-1">
        <Alertbox icon={<Mail />}>
          <StyledText>Caso não tenha encontrado o e-mail, verifique sua caixa de Spam.</StyledText>
        </Alertbox>
      </div>

      {!hasError && (
        <Alertbox>
          <StyledText>O código é privado. Não compartilhe essa informação com ninguém.</StyledText>
        </Alertbox>
      )}
    </>
  )

  if (experimentOn && !modalMode) {
    return (
      <NewPageWrapper>
        {isSubmitting && <LoadingBackdrop />}
        <TwoColumnWrapper>
          <LeftColumn>
            <div>
              <span className="typo-body-large mb-2" style={{ fontSize: '32px' }}>
                Agora, digite o código enviado para o e-mail
              </span>
              <div className="flex items-center gap-1">
                <Avatar size="small" />
                <span className="typo-body-medium font-bold">{email}</span>
              </div>
            </div>
            <NewDesktopFooter>
              <TermsAndPrivacyNotice
                onPrivacyClick={onPrivacyLinkClick}
                onTermsClick={onTermsLinkClick}
              />
            </NewDesktopFooter>
          </LeftColumn>
          <RightColumn>
            <NewMobileHeader>
              <span className="typo-title-medium mb-2">
                Agora, digite o código enviado para o e-mail
              </span>
              <div className="flex items-center gap-1">
                <Avatar size="small" />
                <span className="typo-body-medium font-bold">{email}</span>
              </div>
            </NewMobileHeader>
            <NewCardContent>
              {pincodeFormContent}
              <HideOnMobile>
                <div className="flex mt-2 justify-center">
                  <Link size="medium" onClick={handleBackClick}>
                    Voltar
                  </Link>
                </div>
              </HideOnMobile>
            </NewCardContent>
          </RightColumn>
        </TwoColumnWrapper>
        <NewMobileFooter>
          <TermsAndPrivacyNotice
            onPrivacyClick={onPrivacyLinkClick}
            onTermsClick={onTermsLinkClick}
          />
        </NewMobileFooter>
      </NewPageWrapper>
    )
  }

  return (
    <Content modalMode={modalMode}>
      {isSubmitting && <LoadingBackdrop />}
      <ContentContainer type="outlined" modalMode={modalMode}>
        <ContentWrapper>
          <div
            className="flex flex-col"
            style={{
              paddingLeft: !modalMode && !isMobile && 'var(--spacing-7)',
              paddingRight: !modalMode && !isMobile && 'var(--spacing-7)',
              paddingBottom: !modalMode && 'var(--spacing-3)',
              paddingTop: !modalMode && 'var(--spacing-3)',
            }}
          >
            <div className="flex mb-3 justify-center">
              <span className="typo-title-medium">Acesse sua conta</span>
            </div>
            <SentTo email={email} />
            {pincodeFormContent}
            <div className="flex mb-2" />
            <div className="flex justify-start">
              <Link
                size="medium"
                onClick={() => {
                  handleBackClick()
                }}
              >
                Voltar
              </Link>
            </div>
          </div>
        </ContentWrapper>
      </ContentContainer>
    </Content>
  )
}

SplitLoginEmailPinCodeCheckTemplate.propTypes = {
  email: PropTypes.string,
  onSuccess: PropTypes.func,
  onBackClick: PropTypes.func,
  onChallengePinCodeCall: PropTypes.func,
  abTests: PropTypes.string,
  onPhoneNotValidatedError: PropTypes.func,
  sessionTokens: PropTypes.object,
  onAccountNotValidated: PropTypes.func,
  onAccountMustValidate: PropTypes.func,
  modalMode: PropTypes.bool,
  onAccountCompleteData: PropTypes.func,
  onPrivacyLinkClick: PropTypes.func,
  onTermsLinkClick: PropTypes.func,
}
